import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPencil, faPlus, faTrashAlt } from '@fortawesome/pro-light-svg-icons'

import {
  Box, Button, DashboardModule, Text,
} from '@domain-group/suit-theme'

import usePortalOption from '@hooks/usePortalOption'
import usePortalOptionValue from '@hooks/usePortalOptionValue'
import usePortalOptionValues from '@hooks/usePortalOptionValues'

import { confirmDelete } from '@functions/entity'

import { PortalOptionModel } from '@models/types'

import NodePropertyListItem from './NodePropertyListItem'
import PortalOptionValuesTable from './PortalOptionValuesTable'

const PortalOptionModule = (props: { portalOption: PortalOptionModel }) => {
  const { portalOption: initPortalOption } = props

  const portalOptionPayload = usePortalOption(initPortalOption)

  const {
    callbacks: { createOrEditPortalOption, deletePortalOption: deleteFn },
    hasNodeProperties,
    portalOption,
    portalOption: { node_name, node_properties, title },
  } = portalOptionPayload

  const portalOptionValuePayload = usePortalOptionValue({ portal_option_id: portalOption.id })

  const {
    callbacks: { createOrEditPortalOptionValue },
  } = portalOptionValuePayload

  const portalOptionValuesPayload = usePortalOptionValues({
    filters: {
      portal_option_id: portalOption.id,
    },
  })

  const {
    filteredPortalOptionValues,
    hasFilteredPortalOptionValues,
  } = portalOptionValuesPayload

  return (
    <DashboardModule
      contentBoxProps={{ flexDirection: 'column' }}
      headerRight={<Text color="bodyFontLightColor" fontSize="small">Node: {node_name}</Text>}
      title={title}
    >

      <Box flexDirection="column">
        {hasNodeProperties && (
          // @ts-expect-error TS18048
          node_properties.map(nodeProperty => (
            <NodePropertyListItem
              key={nodeProperty.name}
              nodeProperty={nodeProperty}
            />
          ))
        )}
      </Box>

      {hasFilteredPortalOptionValues && (
        <DashboardModule.ScrollableSection>
          <PortalOptionValuesTable portalOptionValues={filteredPortalOptionValues} />
        </DashboardModule.ScrollableSection>
      )}

      <DashboardModule.Footer
        boxProps={{
          borderTop: hasNodeProperties ? '1px solid' : 'none',
          flexDirection: ['column-reverse', 'row'],
        }}
      >
        <Button
          buttonStyle="secondaryEdit"
          icon={<FontAwesomeIcon icon={faTrashAlt} />}
          marginTop={['medium', 0]}
          onClick={() => confirmDelete({ callbacks: { deleteFn }, strings: { entityName: 'Portal Option' } })}
          // @ts-expect-error TS2322
          size={['medium', 'small']}
          width={['100%', 'fit-content']}
        >
          Delete Portal Option
        </Button>

        <DashboardModule.FooterRight>
          <Box flexDirection={['column', 'row']}>
            <Button
              buttonStyle="secondaryEdit"
              icon={<FontAwesomeIcon icon={faPlus} />}
              marginRight={[0, 'medium']}
              onClick={() => createOrEditPortalOptionValue()}
              // @ts-expect-error TS2322
              size={['medium', 'small']}
              width={['100%', 'fit-content']}
            >
              Add Portal Option Value
            </Button>

            <Button
              buttonStyle="secondaryEdit"
              icon={<FontAwesomeIcon icon={faPencil} />}
              marginTop={['medium', 0]}
              onClick={() => createOrEditPortalOption()}
              // @ts-expect-error TS2322
              size={['medium', 'small']}
              width={['100%', 'fit-content']}
            >
              Edit Portal Option
            </Button>
          </Box>
        </DashboardModule.FooterRight>
      </DashboardModule.Footer>
    </DashboardModule>
  )
}

export default PortalOptionModule
